import { ProfilePromotionLinks, User } from "src/models";
import { UserSessionTypes } from "src/store/types/user.session.types";
import { createAction } from "src/store/actions/create.action";

export namespace UserSessionAction {

    export const showLoading = () => createAction(UserSessionTypes.SHOW_USER_SESSION_LOADING);
    export const hideLoading = () => createAction(UserSessionTypes.HIDE_USER_SESSION_LOADING);

    export const requestLoginCode = (phone: string) => createAction(UserSessionTypes.REQUEST_LOGIN_CODE, phone);
    export const verifyLoginCode = (id: number, phone: string, code: string) => createAction(UserSessionTypes.VERIFY_LOGIN_CODE, { id, code, phone });
    export const login = (user: User) => createAction(UserSessionTypes.LOGIN_USER, user);
    export const logout = () => createAction(UserSessionTypes.LOGOUT_USER);
    export const clearLoginInfos = () => createAction(UserSessionTypes.CLEAR_LOGIN_INFO);

    export const requestUserInfo = () => createAction(UserSessionTypes.REQUEST_USER_INFO);
    export const setUser = (user?: User) => createAction(UserSessionTypes.SET_USER_INFO, user);

    export const updateProfile = (model: any) => createAction(UserSessionTypes.UPDATE_PROFILE, model);

    export const pwaGuidSeen = () => createAction(UserSessionTypes.SEE_PWA_GUID);
    export const pwaGuidUnSeen = () => createAction(UserSessionTypes.UN_SEE_PWA_GUID);

    export const closePackageBanner = () => createAction(UserSessionTypes.HIDE_PACKAGE_BANNER);

    export const remindProfileCompleteLater = (link: ProfilePromotionLinks) => createAction(UserSessionTypes.REMIND_PROFILE_COMPLETE_LATER, link)
}